import React, { useEffect, useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Toaster, toast } from 'sonner';
import { apiGet } from '../utils/apiClient';
import { RecipeDetail } from './RecipeDetail';
import { normalizeRecipeDetail } from '../utils/normalizeRecipeDetail';

export function RecipeDetailPage() {
  const { recipeId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const [recipe, setRecipe] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        setLoading(true);
        const raw = await apiGet(`/recipes/${encodeURIComponent(String(recipeId || ''))}`);
        if (!raw) {
          if (!cancelled) {
            toast.error('Recipe not found');
            navigate('/AllRecipes', { replace: true });
          }
          return;
        }
        const normalized = normalizeRecipeDetail(raw);
        const isSharedLink = new URLSearchParams(location.search).get('shared') === 'true';
        if (isSharedLink) {
          normalized.shared = true;
        }
        if (!cancelled) {
          setRecipe(normalized);
        }
      } catch (e) {
        console.warn('Failed to load recipe for deep link:', e);
        if (!cancelled) {
          toast.error('Unable to load recipe');
          navigate('/AllRecipes', { replace: true });
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [recipeId, navigate, location.search]);

  const handleBack = () => {
    navigate('/AllRecipes');
  };

  const handleTabChange = (tab) => {
    switch (tab) {
      case 'shopping-list':
        navigate('/ShoppingList');
        break;
      case 'meal-plan':
        navigate('/MealPlan');
        break;
      case 'more':
        navigate('/More');
        break;
      case 'recipes':
      default:
        navigate('/AllRecipes');
        break;
    }
  };

  if (loading || !recipe) {
    return (
      <>
        <Toaster position="top-center" />
        <div className="min-h-screen flex items-center justify-center bg-[#F8F7F5]">
          <p className="text-[#757575]">Loading recipe…</p>
        </div>
      </>
    );
  }

  return (
    <>
      <Toaster position="top-center" />
      <RecipeDetail
        recipe={recipe}
        onBack={handleBack}
        activeTab="recipes"
        onTabChange={handleTabChange}
        onServesChange={() => {}}
      />
    </>
  );
}

export default RecipeDetailPage;
